<template>
    <div class="flex justify-left w-full h-full">
        <vs-checkbox
            :checked=params.data.is_default
            :disabled="true"
        ></vs-checkbox
        >
    </div>
</template>

<script>
export default {
  name: "CheckboxCellComponent",
  data () {
    return {

    }
  }
}
</script>